import {createStore} from 'easy-peasy';
import models from 'store/models';

const store = createStore(models);

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept('store/models', () => {
      store.reconfigure(models);
    });
  }
}

export default store;
